import AttendanceChartUpdateCard from "../../components/Notification/NotificationCards/AttendanceChartUpdateCard.component";
import CashInflowCard from "../../components/Notification/NotificationCards/CashInflowCard.component";
import CashOutflowCard from "../../components/Notification/NotificationCards/CashOutflowCard.component";
import NewEventCard from "../../components/Notification/NotificationCards/NewEventCard.component";
import NewMeetingCard from "../../components/Notification/NotificationCards/NewMeetingCard.component";
import NewPollingCard from "../../components/Notification/NotificationCards/NewPollingCard.component";
import NewStudentAdmission from "../../components/Notification/NotificationCards/NewStudentAdmission.component";
import PollingResult from "../../components/Notification/NotificationCards/PollingResult.component";
import StudentResult from "../../components/Notification/NotificationCards/StudentResult.component";
import Body from "./Body";
import { useState } from "react";
const Notification = () => {
  const [notificationData, setNotificationData] = useState([
    {
      date: "2025-06-23",
      entries: [
        {
          id: "stu1",
          type: "student_arrival",
          title: "New student arrived",
          timestamp: "2024-10-20T09:30:00",
          studentId: "SM1024720",
          profileImage: "https://randomuser.me/api/portraits/men/52.jpg",
          profile: {
            name: "Sofikul Alam",
            phone: "9876543210",
            email: "sofikulalam@gmail.com",
          },
        },
        {
          id: "meet1",
          type: "meeting_created",
          title: "New meeting created",
          timestamp: "2024-10-20T09:30:00",
          details: {
            whom: "Board members",
            subject: "Board meeting",
            time: "12:30 PM",
            date: "2024-11-25",
            venue: "Online",
          },
        },
        {
          id: "event1",
          type: "event_created",
          title: "New event created",
          timestamp: "2024-10-20T09:30:00",
          details: {
            eventName: "Guardian meeting",
            subject: "Board meeting",
            time: "12:30 PM",
            startDate: "2024-11-25",
            endDate: "2024-11-25",
            venue: "32 B, Kolkata, 700156",
          },
        },
        {
          id: "poll1",
          type: "poll_created",
          title: "New poll created",
          timestamp: "2024-10-20T09:30:00",
          purpose: "Select HOD",
          endTime: "2025-10-02T12:30:00",
          button: {
            label: "Vote now",
            action: "vote",
          },
        },
      ],
    },
    {
      date: "2024-10-17",
      entries: [
        {
          id: "poll_result1",
          type: "poll_result",
          title: "Poll result released",
          timestamp: "2024-10-20T09:30:00",
          purpose: "Select HOD",
          endTime: "2025-10-02T12:30:00",
          results: [
            {
              name: "Kamrul Haque",
              designation: "Teacher in Charge",
              percentage: 28,
              color: "#D1CBA2",
              backgroundColor: "#F5F3D8",
            },
            {
              name: "Kamrul Haque",
              designation: "Teacher in Charge",
              percentage: 42,
              color: "#7EC6C2",
              backgroundColor: "#DDF4F2",
            },
            {
              name: "Kamrul Haque",
              designation: "Teacher in Charge",
              percentage: 14,
              color: "#A88DC6",
              backgroundColor: "#E7DFF3",
            },
            {
              name: "Kamrul Haque",
              designation: "Teacher in Charge",
              percentage: 5,
              color: "#72BD9F",
              backgroundColor: "#DCF0E8",
            },
            {
              name: "Kamrul Haque",
              designation: "Teacher in Charge",
              percentage: 4,
              color: "#E39C9C",
              backgroundColor: "#FCEAEA",
            },
            {
              name: "Kamrul Haque",
              designation: "Teacher in Charge",
              percentage: 7,
              color: "#93B7E5",
              backgroundColor: "#E3ECF9",
            },
          ],
        },

        {
          id: "exam1",
          type: "result_ready",
          title: "Result ready",
          timestamp: "2024-10-20T09:30:00",
          examName: "First terminal examination",
          classes: "All classes",
          button: {
            label: "View result",
            action: "view_result",
          },
        },
        {
          id: "attendance1",
          type: "attendance_chart",
          title: "Attendance chart updated",
          timestamp: "2024-10-20T09:30:00",
          button: {
            label: "View report",
            action: "view_attendance",
          },
        },
        {
          id: "finance1",
          type: "financial_inflow",
          title: "Financial inflow",
          timestamp: "2024-10-20T09:30:00",
          credited: "20,456",
          into: "Fees",
          button: {
            label: "View result",
            action: "view_finance",
          },
        },
      ],
    },
    {
      date: "2025-01-01",
      entries: [
        {
          id: "finance2",
          type: "financial_outflow",
          title: "Financial outflow",
          timestamp: "2024-10-20T09:30:00",
          debited: "20,456",
          from: "Material & resources",
          button: {
            label: "View result",
            action: "view_finance",
          },
        },
      ],
    },
  ]);
  const renderNotifiCards = (type, data) => {
    if (type === "poll_created") {
      return <NewPollingCard data={data} />;
    } else if (type === "event_created") {
      return <NewEventCard data={data} />;
    } else if (type === "meeting_created") {
      return <NewMeetingCard data={data} />;
    } else if (type === "student_arrival") {
      return <NewStudentAdmission data={data} />;
    } else if (type === "poll_result") {
      return <PollingResult data={data} />;
    } else if (type === "result_ready") {
      return <StudentResult data={data} />;
    } else if (type === "attendance_chart") {
      return <AttendanceChartUpdateCard data={data} />;
    } else if (type === "financial_inflow") {
      return <CashInflowCard data={data} />;
    } else if (type === "financial_outflow") {
      return <CashOutflowCard data={data} />;
    } else {
      return <h1> Not Created yet {type}</h1>;
    }
  };
  const _this = { notificationData, setNotificationData, renderNotifiCards };
  return <Body {..._this} />;
};

export default Notification;
